<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="rebekah-the-gifted-girl">
<h1><br/><br/><br/><br/><br/>Rebekah, the Gifted Girl</h1>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?6fbe6e01